window.smartTable = function (options) {
    // var options = {
    //     pkgUrl:null,
    //     flUrl:null,
    //     apiSelectionUrl:null
    // }
    var sounds = true;
    window.disableSound = function () {
        sounds = false;
    }
    window.enableSound = function () {
        sounds = false;
    }

    var mapping = options.mapping || {
        0: 'db',
        1: 'of',
        2: 'from_company_name',
        3: 'from_name',
        4: 'pickup_contact_name',
        5: 'package_count',
        6: 'cod',
    };
    var CSPAN = options.cspan || 7;
    var CFROM = (options.cfrom || 1) + (options.retourReasons ? 1 : 0);
    var form = options.form || "#mainForm, #assignForm, .assignForm";

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    $(function () {
        var closeEl = function () {
            return $("<a tabindex='-1' class='btn btn-danger btn-sm float-right action-remove' title='Eltávolítás'><i class='fas fa-window-close' /></a>").attr('href', '#');
        };
        var flEl = function (url) {
            return $("<a tabindex='-1' class='btn btn-secondary btn-sm float-right' target='_blank' title='Címke'><i class='fas fa-pager'></i></a>").attr('href', url);
        }
        var detEl = function (url) {
            return $("<a tabindex='-1' class='btn btn-secondary btn-sm float-right' target='_blank' title='Csomag részletek'><i class='fas fa-eye'></i></a>").attr('href', url);
        }

        var cancel = function () {
            $(document).trigger('frmEnable');
        }

        var modal = function (title, messages, submit, style = null) {
            var $modal = $('#modal');
            $modal.find('.modal-title').text(title);
            var $ul = $('<ul/>');
            for (var message of messages) {
                $('<li>').text(message).appendTo($ul);
            }
            $modal.find('.modal-body').html('').append($ul);
            $modal.find('.modal-header').removeClass('alert-success, alert-danger, alert-warning, alert-info').addClass(style ? style : (submit ? 'alert-warning' : 'alert-danger'));

            $modal.find('.save').toggleClass('d-none', !submit)
            if (submit) {
                $modal.find('.save').unbind('click').bind('click', submit)
            }
            $modal.find('.close, [data-dismiss="modal"]').unbind('click').bind('click', cancel);

            // Bind cancel to ESC key
            $(document).unbind('keydown.modal').bind('keydown.modal', function (e) {
                if (e.keyCode === 27) { // ESC key
                    cancel();
                }
            });

            // Clean up event listener when modal is hidden
            $modal.off('hidden.bs.modal.cancel').on('hidden.bs.modal.cancel', function () {
                $(document).unbind('keydown.modal');
            });

            $modal.modal('show');
        }
        var lastFocus = null;
        $('.modal').on('show.bs.modal', function () {
            lastFocus = document.activeElement
        }).on('shown.bs.modal', function () {
            $(this).find('.autofocus, button:not(.d-none):last').first().focus();
        }).on('hidden.bs.modal', function () {
            $(lastFocus).focus();
            lastFocus = null;
        });
        $('#ordertable').on('click', '.action-remove', function () {
            $(this).parents('tr').remove();
            return false;
        })

        var canSubmit = true;
        var shouldSubmit = false;

        var play = function (method, data) {
            if (!sounds) {
                return;
            }
            $('audio').map(function (i, el) {
                el.pause();
            })
            if (data.customAudio) {
                $("<audio/>").prop('src', data.customAudio).appendTo('body').on('load', function () {
                    this.play();
                }).get(0).play();
            } else {
                $("#sound" + method).get(0).currentTime = 0;
                $("#sound" + method).get(0).play();
            }
        }

        var ajaxApi = function ($this, $row) {
            $.ajax({
                url: options.apiSelectionUrl, method: 'GET', data: {id: $this.val()}, error: function (data) {
                    if (sounds) {
                        $("#soundError").get(0).currentTime = 0;
                        $("#soundError").get(0).play();
                    }
                    console.error(data);
                    canSubmit = true;
                    alert(_(data.responseJSON.errors).values().join(', ') || data.statusText);
                }, success: function (data) {
                    $row.attr('className', '');
                    $row.find('.action-buttons').html('');
                    $row.find('.action-buttons').append(closeEl());
                    $row.find('td').first().attr('title', '');

                    if ($table.find("input").not($this).is(function () {
                        return $(this).val() == $this.val();
                    })) {
                        data.warning = "A csomag már beolvasásra került.";
                    }
                    if (data.errors) {
                        data.error = _(data.errors).values().join('; ')
                    }
                    if (data.error) {
                        $row.find("td").each(function (ind) {
                            if (ind == CFROM) $(this).attr("colspan", CSPAN).html(data.error);
                            if (ind > CFROM) $(this).hide();
                        });
                        if (data.item && data.item.id) {
                            $row.find('.action-buttons').append(flEl(options.flUrl.replace(/%/g, data.item.id)));
                            $row.find('.action-buttons').append(detEl(options.pkgUrl.replace(/%/g, data.item.id)));
                        }
                        $row.addClass('table-danger');
                        $this.addClass("ierror");
                        play('Error', data)
                        if (sounds) {
                            if (data.customAudio) {
                                console.log('playing custom sound:', data.customAudio)
                                $("<audio/>").prop('src', data.customAudio).appendTo('body').on('load', function () {
                                    this.play();
                                }).get(0).play();
                            } else {
                                $("#soundError").get(0).currentTime = 0;
                                $("#soundError").get(0).play();
                            }
                        }
                    } else if (data.warning) {
                        $row.find("td").each(function (ind) {
                            if (ind == CFROM) $(this).attr("colspan", CSPAN).html(data.warning);
                            if (ind > CFROM) $(this).hide();
                        });
                        if (data.item.id) {
                            $row.find('.action-buttons').append(flEl(options.flUrl.replace(/%/g, data.item.id)));
                            $row.find('.action-buttons').append(detEl(options.pkgUrl.replace(/%/g, data.item.id)));

                        }
                        $row.addClass('table-warning');
                        $this.addClass("iwarning");
                        play('Warning', data)
                    } else if (data.notice) {
                        $row.find("td").each(function (ind) {
                            $(this).attr("colspan", 1).show();
                            $this.addClass("iinfo");
                            $row.addClass('table-info');
                            if (mapping[ind - CFROM]) {
                                $(this).html(data.item[mapping[ind - CFROM]]);
                            }
                        });
                        $row.find('.action-buttons').append(flEl(options.flUrl.replace(/%/g, data.item.id)));
                        $row.find('.action-buttons').append(detEl(options.pkgUrl.replace(/%/g, data.item.id)));
                        $row.data("data", data);

                        play('Notice', data);
                        // if(sounds){
                        //     if(data.customAudio){
                        //         console.log('playing custom sound:',data.customAudio)
                        //         $("<audio/>").prop('src',data.customAudio).appendTo('body').on('load',function(){
                        //         this.play();
                        //         }).get(0).play();
                        //     }else {
                        //         $("#soundNotice").get(0).currentTime = 0;
                        //         $("#soundNotice").get(0).play();
                        //     }
                        // }
                        $row.find('td').first().attr('title', data.notice.join("<br>"))
                            .tooltip({'html': true, 'placement': 'right'}).tooltip('show');
                    } else if (data.item) {
                        $row.find("td").each(function (ind) {
                            $(this).attr("colspan", 1).show();
                            $this.addClass("isuccess");
                            $row.addClass('table-success');
                            if (mapping[ind - CFROM]) {
                                $(this).html(data.item[mapping[ind - CFROM]]);
                            }
                        });
                        $row.find('.action-buttons').append(flEl(options.flUrl.replace(/%/g, data.item.id)));
                        $row.find('.action-buttons').append(detEl(options.pkgUrl.replace(/%/g, data.item.id)));
                        $row.data("data", data);

                        play('Success', data);
                        // if(sounds){
                        //     $("#soundSuccess").get(0).currentTime=0;
                        //     $("#soundSuccess").get(0).play();
                        // }
                    }
                    $row.find('.action-buttons').show().parent().show();
                    $row.data('data', data);

                    canSubmit = true;
                    if (shouldSubmit) {
                        $(form).trigger('submit');
                    }
                }

            });
        }
        var ajaxApiDebounced = debounce(ajaxApi, 100);

        var $table = $("#ordertable").on("futar:changed", "input.interactive", function () {
            var $this = $(this);
            var $row = $this.parents("tr");
            $this.removeClass("iwarning ierror isuccess");
            $row.attr("class", '');
            canSubmit = false;
            ajaxApi($this, $row);
        }).on('futar:append', function (e, el) {
            var $this = $(el);
            var $row = $this.parents("tr");

            $row.data({data: {item: {package_count: 1}}})
            $this.removeClass("iwarning ierror isuccess");
            $row.attr('className', '');
            $row.find('.action-buttons').html('');
            $row.find('.action-buttons').append(closeEl());

            $row.find("td").each(function (ind) {
                if (ind == CFROM) $(this).attr("colspan", CSPAN).show().text("(Betöltve)");
                if (ind > CFROM) $(this).hide();
            });
            append();
        }).on("blur futar:refresh", "input.interactive", function () {
            var $this = $(this);
            var $row = $this.parents("tr");
            if ($this.data('old') !== $this.val()) {
                $this.data('old', $this.val());

                $this.removeClass("iwarning ierror isuccess");
                $row.attr("class", '');

                if ($this.val().trim() === "") {
                    $row.find("td").each(function (ind) {
                        if (ind == CFROM) $(this).attr("colspan", CSPAN).html("");
                        if (ind > CFROM) $(this).hide();
                    });
                    $row.data("data", {});
                } else {
                    canSubmit = false;
                    ajaxApiDebounced($this, $row);
                }
            }
            append();
            ensureReason($this)
        }).on("change keyup", "input.interactive", function () {
            var $this = $(this),
                val = $this.val();
            val = val.match(/^\*(\d+)\*$/);
            if (val) {
                $this
                    .val(val[1])
                    .trigger("futar:refresh")
                    .closest("tr").next().find("input").focus();
            }
        }).on("keydown", "input.interactive", function (e) {
            if (e.which == 13) {
                $(this).trigger("futar:refresh");
                if (e.ctrlKey || e.metaKey) {
                    $(".go").click();
                } else {
                    $(this).closest("tr").next().find("input").focus();
                }
                return false;
            }
            return true;
        });
        var append = function () {
            if ($table.find("input").filter(function () {
                return $(this).val() === "";
            }).length < 2) {
                $table.append('<tr><td><input autocomplete="off" name="data[]" class="interactive"></td>' +
                    options.retourReasons +
                    ('<td></td>'.repeat(CSPAN)) +
                    '<td><div class="btn-group action-buttons text-right" role="group"></div></td></tr>'
                );
            }
        };
        var ensureReason = function ($this) {
            if (options.retourReasons) {
                var oldVal = $this.parents('tr').find('.reason').val();
                // $this.parents('tr').next().find('.reason').val(oldVal)
            }
        }


        window.addEventListener('keypress', function (e) {
            if (document.activeElement == document.body) {
                $('.interactive').filter(function () {
                    return !$(this).val() || $(this).val().trim() === '';
                }).first().focus();

            }
        });
        // append();
        // append();
        // $('input.interactive:not([value]):first').get(0).focus();

        $(form).submit(function () {
            if (!canSubmit) {
                shouldSubmit = true;
                return false;
            }
            try {
                var warnings = [];
                var errors = [];
                $table.find("tr").each(function () {
                    var d = $(this).data("data") || {};
                    if (d.error) {
                        errors.push(d.error);
                    }
                    if (d.warning) {
                        // http://audioblocks.com/stock-audio/warning-beep-sound-effect.html
                        warnings.push(d.warning);
                    }
                });

                var packsData = {};
                var foundPacks = {};
                var foundPackPieces = new Set();
                var pieceCount = 0;
                $table.find("tr").each(function () {
                    var rowData = $(this).data("data");
                    if (rowData && rowData.item) {
                        packsData[rowData.item.id] = rowData.item;
                        var ok = true;
                        if (rowData.item.of > 0) {
                            if (foundPackPieces.has(rowData.item.id + '-' + rowData.item.of)) {
                                warnings.push(`${rowData.item.barcode} többször is szerepel.`);
                                ok = false;
                            } else {
                                foundPackPieces.add(rowData.item.id + '-' + rowData.item.of);
                            }
                        }
                        if (!foundPacks[rowData.item.id]) foundPacks[rowData.item.id] = 0;
                        if (ok) {
                            foundPacks[rowData.item.id]++;
                        }
                        pieceCount++;

                        if ($(this).find('[required] option[hidden]:selected').length) {
                            errors.push("Kötelező mező nem lett kitoltve.");
                            $(this).find('[required]').addClass('bg-danger').on('focus.warning', function () {
                                $(this).removeClass('bg-danger').off('focus.warning')
                            });
                        }
                    }
                });
                var packageCount = Object.keys(packsData).length;

                if (packageCount == 0) {
                    errors.push('Nincs kivalasztott csomag');
                }

                for (var id in packsData) {
                    console.log([foundPacks[id], packsData[id].package_count])
                    if (foundPacks[id] < packsData[id].package_count) {
                        warnings.push("A " + id + " csomagból " + foundPacks[id] + "/" + packsData[id].package_count + " lett csak kiválasztva.");
                    }
                    if (foundPacks[id] > packsData[id].package_count) {
                        warnings.push("A " + id + " csomagból " + foundPacks[id] + "/" + packsData[id].package_count + " túl sok lett kiválasztva.");
                    }
                }

                if (errors.length) {
                    if (sounds) {
                        $("#soundError").get(0).currentTime = 0;
                        $("#soundError").get(0).play();
                    }
                    var title = (errors.length == 1 ? "HIBA!\nAz alábbi hiba miatt nem lehet elküldeni:" : "HIBA!\nAz alábbi hibák miatt nem lehet elküldeni:");

                    modal(title, errors, false);

                    return false;
                }
                if (warnings.length) {
                    if (sounds) {
                        $("#soundWarning").get(0).currentTime = 0;
                        $("#soundWarning").get(0).play();
                    }

                    modal(
                        "Figyelmeztetés!",
                        warnings,
                        function () {
                            $(form).off('submit').submit();
                        }
                    );
                    return false;
                }
                if ($(form).data('confirm')) {
                    modal('Megerősítés',
                        [`Biztos, hogy ${packageCount} címre / ${pieceCount} darabszámú küldeményt kíván feladni?`, 'Ha a tovább gombra kattint a művelet nem visszavonható'], () => {
                            $(form).off('submit').submit();
                        }, 'alert-info');
                    return false;

                }
                console.log('all good')

                return true;
            } catch (e) {
                console.error(e);
                return false;
            }
        });

    });
}
